import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { gerarLinkReduzido } from '../../utils/FunctionUtils';

interface Props {
	numeroRifa?: string
}

interface State {
	showModal: boolean
}

class CompartilhamentoRifa extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			showModal: false,
		};
	}

	handleClose = () => {
		this.setState({ showModal: false });
	}

	handleShow = () => {
		this.setState({ showModal: true });
	}

	render() {
		const {
			numeroRifa
		} = this.props;
		const {
			showModal
		} = this.state;
		
		const linkReduzido = numeroRifa ? gerarLinkReduzido(numeroRifa) : "https://www.rifatech.com";
		const textoCompartilhamento = "Eu%20apoio%20esta%20campanha!%20Você%20também%20pode%20ajudar.%20Uma%20boa%20ação%20concebe%20um%20sorriso%20a%20mais.%20Mais%20generosidade%2C%20mais%20felicidade%20%3A)%20";
		const linkTwitter = `https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw&text=${textoCompartilhamento}&tw_p=tweetbutton&url=${linkReduzido}`;
		const linkFacebook = `https://www.facebook.com/sharer/sharer.php?u=${linkReduzido}`;
		const linkWhatsAppWeb = `https://web.whatsapp.com/send?text=${textoCompartilhamento}${linkReduzido}`;
		const linkWhatsAppMobile = `whatsapp://send?text=${textoCompartilhamento}${linkReduzido}`;

		const copiarLink = () => {
			const text = linkReduzido;

			// Fallback para navegadores que não suportam clipboard
			if (!navigator.clipboard) {
				const textArea = document.createElement("textarea");
				textArea.value = text;
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					document.execCommand("copy");
					alert("Copiado para a área de transferência!");
				} catch (err) { }

				document.body.removeChild(textArea);
				return;
			}

			navigator.clipboard.writeText(text).then(
				() => {
					alert("Copiado para a área de transferência!");
				},
				(err) => {
				}
			);
		}

		return (
			<section className="panel-bg-secondary text-center p-3 p-md-5 mb-3">
				{/* Modal com link de compartilhamento */}
				<Modal show={showModal} onHide={this.handleClose} centered>
					<Modal.Body>
						Compartilhar link
						<br /><br />
						<div className="form-control">
							<a href={linkReduzido}
								id="input-endereco-rifa">
								{linkReduzido}
							</a>
						</div>
						<br />
						<div className="d-flex">
							<Button variant="secondary" className="mx-auto" onClick={this.handleClose}>
								Fechar
							</Button>
						</div>
					</Modal.Body>
				</Modal>

				<span className="title-sm-common title-sm-secondary"> Compartilhe! </span>
				<div className="mt-4">
					<Row style={{ margin: "0 auto", maxWidth: "280px", flexWrap: "nowrap", WebkitFlexWrap: "nowrap" }}>
						{/* Botão com link da rifa para computador */}
						<Col style={{ padding: "0" }}>
							<div className="d-none d-lg-inline-block mx-2 icone-fundo-colorido">
								<button
									id="compartilhar-link"
									className="btn icone-compartilhar icon_share_link"
									title="Copiar Link"
									aria-label="Copiar Link"
									onClick={copiarLink}
									type="button" />
							</div>

							{/* Botão com link da rifa para celular */}
							<div className="d-lg-none mx-2 icone-fundo-colorido">
								<button type="button"
									data-toggle="modal"
									data-target="#modal-link-rifa"
									id="compartilhar-link-celular"
									className="js-copy-btn btn icone-compartilhar icon_share_link"
									title="Copiar Link"
									onClick={this.handleShow}>
									{linkReduzido}
								</button>
							</div>
						</Col>

						{/* Botão Facebook */}
						<Col style={{ padding: "0" }}>
							<div className="mx-2 icone-fundo-colorido">
								<a className="btn icone-compartilhar icon_facebook"
									title="Compartilhar no Facebook"
									href={linkFacebook}
									rel="noopener noreferrer"
									target="_blank">
									{linkFacebook}
								</a>
							</div >
						</Col>

						{/* Botão WhatsApp Web */}
						<Col style={{ padding: "0" }}>
							<div className="d-none d-sm-inline-block mx-2 icone-fundo-colorido">
								<a className="btn icone-compartilhar icon_whatsapp"
									title="Compartilhar no WhatsApp"
									href={linkWhatsAppWeb}
									rel="noopener noreferrer"
									target="_blank">
									{linkWhatsAppWeb}
								</a>
							</div >

							{/* Botão WhatsApp Mobile */}
							<div className="d-sm-none mx-2 icone-fundo-colorido">
								<a className="btn icone-compartilhar icon_whatsapp"
									title="Compartilhar no WhatsApp"
									href={linkWhatsAppMobile}
									rel="noopener noreferrer"
									target="_blank">
									{linkWhatsAppMobile}
								</a>
							</div >
						</Col>

						{/* Botão Twitter */}
						<Col style={{ padding: "0" }}>
							<div className="mx-2 icone-fundo-colorido">
								<a className="btn icone-compartilhar icon_twitter"
									title="Compartilhar no Twitter"
									href={linkTwitter}
									rel="noopener noreferrer"
									target="_blank">
									{linkTwitter}
								</a>
							</div>
						</Col>
					</Row>
				</div>
			</section >
		);
	}
}

export default CompartilhamentoRifa;